import TripleStateSwitch from '../../../../../../../Shared/TripleStateSwitch/TripleStateSwitch';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../../../../context';

const IsMarkedCompletedFilterSwitch = () => {
    const dispatch = useDispatch();
    const currentIsMarkedCompletedFilterValue = useSelector(
        (state) => state.daylight.codeIsMarkedCompletedFilter
    );

    const isMarkedCompletedProps = {
        defaultState: getDefaultState(currentIsMarkedCompletedFilterValue),
        states: {
            falseState: {
                title: 'No',
                onClick: () =>
                    dispatch(
                        actions.daylight.setCodeIsMarkedCompletedFilter(false)
                    ),
            },
            neutralState: {
                title: 'Both',
                onClick: () =>
                    dispatch(
                        actions.daylight.setCodeIsMarkedCompletedFilter(null)
                    ),
            },
            trueState: {
                title: 'Yes',
                onClick: () =>
                    dispatch(
                        actions.daylight.setCodeIsMarkedCompletedFilter(true)
                    ),
            },
        },
    };

    return (
        <div className="d-flex justify-content-between align-items-center mt-2">
            <span>Show Marked Completed</span>
            <TripleStateSwitch {...isMarkedCompletedProps} />
        </div>
    );
};

const getDefaultState = (isMarkedCompletedFilterValue) => {
    if (isMarkedCompletedFilterValue === null) {
        return 'neutral';
    }
    return isMarkedCompletedFilterValue.toString();
};

export default IsMarkedCompletedFilterSwitch;
